module.exports = __webpack_public_path__ + "static/media/Hull colour -  pure white RAL 9010 & 3 x black grey RAL 702 waterlines.d88c696c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x black grey RAL 702 waterlines.jpg
// module id = 43
// module chunks = 0